
import Checker from 'vux/src/components/checker/checker.vue'
import CheckerItem from 'vux/src/components/checker/checker-item.vue'

import myMessage from './myMessage.vue'
import sendMessage from './sendMessage.vue'
import { StationLetterTabOptions, resetTextBylangKey } from '../../../libs/options.js'
export default {
name: 'StationLetter',
components: { myMessage, sendMessage, Checker, CheckerItem },
data() {
return {
tabSelected: 'myMessage'
}
},
computed: {
tabLists() {
return resetTextBylangKey(StationLetterTabOptions, this.$t('mine').stationLetter.pageTab)
}
}
}



// WEBPACK FOOTER //
// ./src/pages/build800/views/My/StationLetter/index.vue